import { Check, ZoomIn } from 'lucide-react';
import type { PhotobookProject } from '@fotoboek/domain';
import { useProjectStore } from '../../state/projectStore';
import { Button } from '../ui/Button';
import { t } from '../../i18n';
import './crop-mode-toolbar.css';

export function CropModeToolbar() {
  const cropElementId = useProjectStore((s) => s.cropElementId);
  const project = useProjectStore((s) => s.project);
  const selection = useProjectStore((s) => s.selection);
  const updateElement = useProjectStore((s) => s.updateElement);
  const exitCropMode = useProjectStore((s) => s.exitCropMode);

  if (!cropElementId || !project) return null;

  const target = selection.target;
  const element = findElement(project, cropElementId);
  if (!element || element.type !== 'photoFrame') return null;

  return (
    <div className="crop-toolbar">
      <ZoomIn size={16} />
      <input
        type="range"
        min={1}
        max={3}
        step={0.01}
        value={element.placement.scale}
        onChange={(e) => {
          if (!target) return;
          updateElement(target, cropElementId, {
            placement: { ...element.placement, scale: Number(e.target.value) },
          } as never);
        }}
      />
      <Button variant="primary" size="sm" onClick={exitCropMode}>
        <Check size={14} />
        {t('editor.cropDone')}
      </Button>
    </div>
  );
}

function findElement(project: PhotobookProject, id: string) {
  for (const page of project.pages) {
    const found = page.elements.find((e) => e.id === id);
    if (found) return found;
  }
  for (const panel of Object.values(project.cover.panels)) {
    const found = panel.elements.find((e) => e.id === id);
    if (found) return found;
  }
  return null;
}
